module.exports = __webpack_public_path__ + "images/flags.a31aa1c5ef763dc96f3b6bc09b18592f.png";